<template>
  <div id="download">
    <NavigationBar />

    <div class="uk-section uk-section-muted">
      <div class="uk-container">
        <h2 class="uk-text-bold uk-text-center">E-Garansi Roomi</h2>
        <div class="uk-flex uk-flex-center">
          <div class="uk-width-1-2@m uk-width-1-1 uk-margin-top">
            <form ref="form" class="uk-form-stacked" @submit.prevent="validate">
              <div class="uk-margin-bottom uk-width-1-1" v-if="errorDefaultSN">
                <div class="uk-alert-danger" uk-alert>
                  <p>
                    {{ errorDefaultSN }}
                  </p>
                </div>
              </div>
              <div class="uk-margin-bottom uk-width-1-1">
                <label
                  class="uk-form-label form-label-custom"
                  for="serial_number"
                >
                  Serial Number<span class="form-label-required-text">*</span>
                </label>
                <div class="uk-form-controls">
                  <input
                    type="text"
                    class="uk-input"
                    placeholder="Serial Number"
                    id="serial_number"
                    v-model="formSubmit.serial_number"
                    :readonly="defaultSN != ''"
                  />
                </div>
              </div>
              <div class="uk-margin-bottom uk-width-1-1">
                <label
                  class="uk-form-label form-label-custom"
                  for="customer_name"
                >
                  Nama Lengkap<span class="form-label-required-text">*</span>
                </label>
                <div class="uk-form-controls">
                  <input
                    type="text"
                    class="uk-input"
                    placeholder="Nama Lengkap"
                    id="customer_name"
                    v-model="formSubmit.customer_name"
                  />
                </div>
              </div>
              <div class="uk-margin-bottom uk-width-1-1">
                <label
                  class="uk-form-label form-label-custom"
                  for="customer_phone"
                >
                  No Whatsapp<span class="form-label-required-text">*</span>
                </label>
                <div class="uk-form-controls">
                  <input
                    type="number"
                    class="uk-input"
                    placeholder="No Whatsapp"
                    id="customer_phone"
                    minlength="10"
                    v-model="formSubmit.customer_phone"
                  />
                  <span
                    >*Minimal 10 digit<br />*Pastikan no anda telah terdaftar
                    whatsapp</span
                  >
                </div>
              </div>
              <div class="uk-margin-bottom uk-width-1-1">
                <hr />
                <b># Informasi Alamat</b>
                <hr />
              </div>
              <div uk-grid>
                <div class="uk-width-1-2@m uk-width-1-1">
                  <label
                    class="uk-form-label form-label-custom"
                    for="customer_province"
                  >
                    Provinsi<span class="form-label-required-text">*</span>
                  </label>
                  <div class="uk-form-controls">
                    <select
                      id="customer_province"
                      class="uk-select"
                      v-model="formSubmit.customer_province"
                      @change="changeCustomerProvince"
                    >
                      <option value="">Pilih Provinsi</option>
                      <option
                        :value="province.id"
                        v-for="(province, index) in provincies"
                        :key="index"
                      >
                        {{ province.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="uk-width-1-2@m uk-width-1-1">
                  <label
                    class="uk-form-label form-label-custom"
                    for="customer_city"
                  >
                    Kota / Kabupaten<span class="form-label-required-text"
                      >*</span
                    >
                  </label>
                  <div class="uk-form-controls">
                    <select
                      id="customer_city"
                      class="uk-select"
                      v-model="formSubmit.customer_city"
                      @change="changeCustomerCity"
                    >
                      <option value="">Pilih Kota / Kabupaten</option>
                      <option
                        :value="city.id"
                        v-for="(city, index) in customer_cities"
                        :key="index"
                      >
                        {{ city.type }} {{ city.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="uk-margin-top uk-margin-bottom" uk-grid>
                <div class="uk-width-1-2@m uk-width-1-1">
                  <label
                    class="uk-form-label form-label-custom"
                    for="customer_district"
                  >
                    Kecamatan<span class="form-label-required-text">*</span>
                  </label>
                  <div class="uk-form-controls">
                    <select
                      id="customer_district"
                      class="uk-select"
                      v-model="formSubmit.customer_district"
                    >
                      <option value="">Pilih Kecamatan</option>
                      <option
                        :value="district.id"
                        v-for="(district, index) in customer_districts"
                        :key="index"
                      >
                        {{ district.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="uk-width-1-2@m uk-width-1-1">
                  <label
                    class="uk-form-label form-label-custom"
                    for="customer_postcode"
                  >
                    Kode Pos<span class="form-label-required-text">*</span>
                  </label>
                  <div class="uk-form-controls">
                    <input
                      type="number"
                      class="uk-input"
                      id="customer_postcode"
                      placeholder="Kode POS"
                      v-model="formSubmit.customer_postcode"
                    />
                    <span>*Hanya bisa diisi angka</span>
                  </div>
                </div>
              </div>
              <div class="uk-margin-botttom uk-width-1-1">
                <label
                  class="uk-form-label form-label-custom"
                  for="customer_address"
                >
                  Alamat Lengkap<span class="form-label-required-text">*</span>
                </label>
                <div class="uk-form-controls">
                  <textarea
                    type="text"
                    class="uk-textarea"
                    placeholder="Alamat Lengkap"
                    id="customer_address"
                    v-model="formSubmit.customer_address"
                  />
                </div>
              </div>
              <div class="uk-margin-bottom uk-margin-top uk-width-1-1">
                <hr />
                <b># Informasi Toko</b>
                <hr />
              </div>
              <div class="uk-margin-bottom uk-width-1-1">
                <label class="uk-form-label form-label-custom" for="store_name">
                  Nama Toko<span class="form-label-required-text">*</span>
                </label>
                <div class="uk-form-controls">
                  <input
                    type="text"
                    class="uk-input"
                    placeholder="Nama Toko"
                    id="store_name"
                    v-model="formSubmit.store_name"
                  />
                </div>
              </div>
              <div class="uk-margin-bottom" uk-grid>
                <div class="uk-width-1-2@m uk-width-1-1">
                  <label
                    class="uk-form-label form-label-custom"
                    for="store_province"
                  >
                    Provinsi Toko
                  </label>
                  <div class="uk-form-controls">
                    <select
                      id="store_province"
                      class="uk-select"
                      v-model="formSubmit.store_province"
                      @change="changeStoreProvince"
                    >
                      <option value="">Pilih Provinsi Toko</option>
                      <option
                        :value="province.id"
                        v-for="(province, index) in provincies"
                        :key="index"
                      >
                        {{ province.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="uk-width-1-2@m uk-width-1-1">
                  <label
                    class="uk-form-label form-label-custom"
                    for="store_city"
                  >
                    Kota / Kabupaten Toko
                  </label>
                  <div class="uk-form-controls">
                    <select
                      id="store_city"
                      class="uk-select"
                      v-model="formSubmit.store_city"
                    >
                      <option value="">Pilih Kota / Kabupaten Toko</option>
                      <option
                        :value="city.id"
                        v-for="(city, index) in store_cities"
                        :key="index"
                      >
                        {{ city.type }} {{ city.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="uk-margin-bottom uk-width-1-1">
                <div class="uk-alert-primary" uk-alert>
                  <p>Pastikan data yang anda isi benar!</p>
                </div>
              </div>
              <div class="uk-width-1-1">
                <button
                  class="uk-button uk-button-primary uk-width-1-1"
                  type="submit"
                  :disabled="disabledButtonSubmit"
                >
                  {{ loadingButton ? "Loading..." : "Simpan" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div id="error_model_whatsapp" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Pemberitahuan</h2>
        <p>
          Mohon maaf, saat ini sedang ada gangguan. <br>Klik link berikut untuk menghubungi CS Tanaka. <a href="https://api.whatsapp.com/send/?phone=628119965111&text=Halo, Saya terkendala saat daftar e-garansi&type=phone_number&app_absent=0" target="_blank">Klik Disini</a>
        </p>
        <p class="uk-text-right">
          <button
            class="uk-button uk-button-default uk-modal-close"
            type="button"
          >
            Tutup
          </button>
        </p>
      </div>
    </div>

    <div id="modal_verification" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <h4 class="uk-text-bold">Verifikasi Whatsapp</h4>
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-width-1-1 uk-margin-bottom uk-margin-top">
          <input
            type="number"
            class="uk-input"
            placeholder="Masukkan Kode Verifikasi"
            v-model="formSubmit.otp"
          />
        </div>
        <div class="uk-width-1-1">
          <button
            class="uk-button uk-button-primary uk-width-1-1"
            @click="verification"
          >
            {{ loadingButtonVerification ? "Loading..." : "Verifikasi" }}
          </button>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
import UIkit from "uikit";

export default {
  name: "eguarantee",
  components: {
    NavigationBar,
    Footer,
  },
  data() {
    return {
      formSubmit: {
        serial_number: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        customer_province: "",
        customer_city: "",
        customer_district: "",
        customer_postcode: "",
        store_name: "",
        store_province: "",
        store_city: "",
        store_address: "",
        otp: "",
      },
      errorDefaultSN: "",
      provincies: [],
      customer_cities: [],
      customer_districts: [],
      store_cities: [],
      loadingButton: false,
      loadingButtonVerification: false,
    };
  },
  mounted() {
    this.getProvincies();
    if (this.defaultSN != "") {
      this.checkSN();
    }
  },
  computed: {
    disabledButtonSubmit() {
      return (
        this.formSubmit.serial_number == "" ||
        this.formSubmit.customer_name == "" ||
        this.formSubmit.customer_phone == "" ||
        this.formSubmit.customer_address == "" ||
        this.formSubmit.customer_province == "" ||
        this.formSubmit.customer_city == "" ||
        this.formSubmit.customer_district == "" ||
        this.formSubmit.customer_postcode == "" ||
        this.formSubmit.store_name == ""
      );
    },
    defaultSN() {
      return this.$route.query.sn ? this.$route.query.sn : "";
    },
  },
  methods: {
    getProvincies() {
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}province`)
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.provincies = data.data;
            } else {
              UIkit.notification({
                status: "danger",
                message: data.message,
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: res.statusText,
            });
          }
        })
        .catch((err) => {
          const response = err.response;
          const data = response.data;
          UIkit.notification({
            status: "danger",
            message: data.message,
          });
        });
    },
    changeCustomerProvince() {
      this.customer_cities = [];
      this.customer_districts = [];
      this.formSubmit.customer_city = "";
      this.formSubmit.customer_district = "";
      if (this.formSubmit.customer_province == "") {
        return;
      }
      const params = {
        province_id: this.formSubmit.customer_province,
      };
      const paramsString = new URLSearchParams(params).toString();
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}city?${paramsString}`)
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.customer_cities = data.data;
            } else {
              UIkit.notification({
                status: "danger",
                message: data.message,
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: res.statusText,
            });
          }
        })
        .catch((err) => {
          const response = err.response;
          const data = response.data;
          UIkit.notification({
            status: "danger",
            message: data.message,
          });
        });
    },
    changeCustomerCity() {
      this.customer_districts = [];
      this.formSubmit.customer_district = "";
      if (this.formSubmit.customer_city == "") {
        return;
      }
      const params = {
        city_id: this.formSubmit.customer_city,
      };
      const paramsString = new URLSearchParams(params).toString();
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}district?${paramsString}`)
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.customer_districts = data.data;
            } else {
              UIkit.notification({
                status: "danger",
                message: data.message,
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: res.statusText,
            });
          }
        })
        .catch((err) => {
          const response = err.response;
          const data = response.data;
          UIkit.notification({
            status: "danger",
            message: data.message,
          });
        });
    },
    changeStoreProvince() {
      this.store_cities = [];
      this.formSubmit.store_city = "";
      if (this.formSubmit.store_province == "") return;
      const params = {
        province_id: this.formSubmit.store_province,
      };
      const paramsString = new URLSearchParams(params).toString();
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}city?${paramsString}`)
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.store_cities = data.data;
            } else {
              UIkit.notification({
                status: "danger",
                message: data.message,
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: res.statusText,
            });
          }
        })
        .catch((err) => {
          const response = err.response;
          const data = response.data;
          UIkit.notification({
            status: "danger",
            message: data.message,
          });
        });
    },
    validate() {
      if (this.formSubmit.customer_phone.length >= 10) {
        this.submit();
      } else {
        UIkit.notification({
          status: "danger",
          message: "Invalid whatsapp number!",
        });
      }
    },
    submit() {
      if (this.loadingButton) return;
      this.loadingButton = true;
      axios
        .post(
          `${process.env.VUE_APP_API_ROOMI_URL}guarantee/check-field`,
          this.formSubmit
        )
        .then((res) => {
          this.loadingButton = false;
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              UIkit.modal("#modal_verification").show();
            } else {
              UIkit.notification({
                status: "danger",
                message: data.message,
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: res.statusText,
            });
          }
        })
        .catch((err) => {
          this.loadingButton = false;
          const response = err.response;
          const data = response.data;
          if (data) {
            if (response.status == 502) {
              UIkit.modal("#error_model_whatsapp").show();
            } else {
              UIkit.notification({
                status: "danger",
                message: data.message,
              });
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: err.toString(),
            });
          }
        });
    },
    verification() {
      if (this.formSubmit.otp == "") {
        UIkit.notification({
          status: "danger",
          message: "Kode verifikasi harus diisi!",
        });
        return;
      }
      if (this.loadingButtonVerification) return;
      this.loadingButtonVerification = true;
      axios
        .post(
          `${process.env.VUE_APP_API_ROOMI_URL}guarantee/submit`,
          this.formSubmit
        )
        .then((res) => {
          this.loadingButtonVerification = false;
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              UIkit.modal("#modal_verification").hide();
              window.location.href = `/e-garansi/cek?sn=${this.formSubmit.serial_number}`;
            }
            UIkit.notification({
              status: data.success ? "success" : "danger",
              message: data.message,
            });
          } else {
            UIkit.notification({
              status: "danger",
              message: res.statusText,
            });
          }
        })
        .catch((err) => {
          this.loadingButtonVerification = false;
          const response = err.response;
          const data = response.data;
          if (data) {
            UIkit.notification({
              status: "danger",
              message: data.message,
            });
          } else {
            UIkit.notification({
              status: "danger",
              message: err.toString(),
            });
          }
        });
    },
    checkSN() {
      this.errorDefaultSN = "";
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}guarantee/check-product/${this.defaultSN}`
        )
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.formSubmit.serial_number = this.defaultSN;
            } else {
              UIkit.notification({
                status: "danger",
                message: data.message,
              });
              this.errorDefaultSN = data.message;
            }
          } else {
            UIkit.notification({
              status: "danger",
              message: data.message,
            });
            this.errorDefaultSN = res.statusText;
          }
        })
        .catch((err) => {
          const response = err.response;
          const data = response.data;
          if (data) {
            UIkit.notification({
              status: "danger",
              message: data.message,
            });
            this.errorDefaultSN = data.message;
          } else {
            UIkit.notification({
              status: "danger",
              message: err.toString(),
            });
            this.errorDefaultSN = err.toString();
          }
        });
    },
  },
};
</script>

<style scoped>
ul.app-desc {
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  line-height: 1;
  width: 50%;
}

ul.app-desc li {
  padding: 2.5px 0;
  text-transform: capitalize;
  color: rgb(164, 173, 184);
  word-spacing: 2px;
  font-weight: 300;
  letter-spacing: 1.5px;
}

ul.app-desc li::after {
  content: "|";
  margin-left: 5px;
  margin-right: 5px;
}

ul.app-desc li:last-child::after {
  content: "";
}

/* ul.uk-slider-items li img {
	height: 200px;
} */

.card-download {
  cursor: pointer;
}

.card-download:hover {
  box-shadow: 0 5px 15px rgb(0 0 0 / 25%) !important;
}

@media screen and (max-width: 639px) {
  .text-container > * {
    text-align: center;
  }

  ul.app-desc {
    margin: auto;
    display: inline-block;
    width: 100%;
  }

  ul.app-desc li a {
    text-align: center;
  }

  ul.app-desc li::after {
    content: "";
  }
}
</style>